import { gateway } from "../../../../gateway";

export interface ClientJob {
  id: number;
  alias?: string;
  type?: "basic" | "advanced";
  status: string;
  isRepetitive?: boolean;
  isVisit?: boolean;
  clientUid: string;
  scopeOfWorkUid?: string;
  eventUid?: string;
  createdAt?: string;
  events?: ClientJobEvent[];
}

export interface ClientJobEvent {
  uid: string;
  startDate: string;
  endDate: string;
  status: string;
  billingInvoiceUid?: string | null;
}

interface GetClientJobsParams {
  clientUid: string;
  billingStatus?: string;
  page?: number;
  pageSize?: number;
}

interface PaginatedResponse<T> {
  items: T[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export const getClientJobs = async ({
  clientUid,
  billingStatus = "NOT_PAID",
  page = 1,
  pageSize = 50,
}: GetClientJobsParams): Promise<PaginatedResponse<ClientJob>> => {
  const token = sessionStorage.getItem("token");

  const response = await gateway.get("/jobs/self", {
    params: { clientUid, billingStatus, page, pageSize },
    headers: { Authorization: `${token}` },
  });

  return response.data.data;
};
